import React from 'react'
import {Header} from 'semantic-ui-react'
import {AccountOverview} from './account-overview'
import {ChangePassword} from './change-password'
import {LeaveAccount} from './leave-account'
import {RegenerateAPIKey} from './regenerate-api-key'
import {UpdateProfile} from './update-profile'
import {ViewAccounts} from './view-accounts'
import {Router} from '@reach/router'
import {SectionMenu} from '../../section-menu'

const AccountSection = ({navigate, location}) => {
  const menuItems = [
    'Overview',
    'Change Password',
    'Leave Account',
    'Regenerate API Key',
    'Update Profile',
    'View Accounts'
  ]
  return (
    <>
      <Header as='h2'>Authentication</Header>
      <SectionMenu isLeftNav={false} navigate={navigate} location={location} menuItems={menuItems}/>
      <Router>
        <AccountOverview default/>
        <ChangePassword path='change-password'/>
        <LeaveAccount path='leave-account'/>
        <RegenerateAPIKey path='regenerate-api-key'/>
        <UpdateProfile path='update-profile'/>
        <ViewAccounts path='view-accounts'/>
      </Router>
    </>
  )
}

export {AccountSection}

export default AccountSection